import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../../config/api";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import CustomFormatDatePicker from "../../../components/CustomFormatDatePicker";
import { PhoneNumberInput } from "../../../components/PhoneNumberInput";

export const AddDriver = () => {
    const navigate = useNavigate();
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [phone, setPhone] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [licenseNumber, setLicenseNumber] = useState<string>("");
    const [licenseExpiryDate, setLicenseExpiryDate] = useState<string>("");
    const [status, setStatus] = useState<string>("available");
    const [enabled, setEnabled] = useState<string>("No");
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [pleaseWaitPopup, setPleaseWaitPopup] =
        useState<boolean>(false);

    useEffect(() => {
        let timer: NodeJS.Timeout;

        if (email.trim() !== "") {
            timer = setTimeout(() => {
                const valid =
                    /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(email.trim());

                setIsEmailValid(valid);
            }, 800);
        } else {
            setIsEmailValid(true);
        }

        return () => clearTimeout(timer);
    }, [email]);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ) => {
        e.preventDefault();

        setPleaseWaitPopup(true);

        const payload = {
            first_name: firstName.trim(),
            last_name: lastName.trim(),
            phone: phone.trim(),
            email: email.trim(),
            license_number: licenseNumber.trim(),
            license_expiry_date: licenseExpiryDate,
            status,
            is_active: enabled === "Yes"
        };

        await axios
            .post(
                `${baseURL}drivers/`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json"
                    },
                    withCredentials: false
                }
            )
            .then((response) => {
                setPleaseWaitPopup(false);
                navigate(-1);
            })
            .catch((error) => {
                setPleaseWaitPopup(false);

                console.error(
                    "Error creating driver:",
                    error
                );
            });
    };


    return (
        <>
            <div className="px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto">

                <div className="w-full bg-white p-4 rounded-md">

                    <h2 className="text-lg font-semibold">
                        Add Driver
                    </h2>

                    <div className="mt-2 p-2">

                        <form onSubmit={handleSubmit}>

                            <div className="w-full">

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            First Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={firstName}
                                            placeholder="First Name"
                                            onChange={(e) =>
                                                setFirstName(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Last Name{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={lastName}
                                            placeholder="Last Name"
                                            onChange={(e) =>
                                                setLastName(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Email{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="email"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={email}
                                            placeholder="Email Address"
                                            onChange={(e) =>
                                                setEmail(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                        {!isEmailValid && (
                                            <p className="text-xs text-red-500 mt-1">
                                                Please enter a valid email address
                                            </p>
                                        )}
                                    </div>

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Phone{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <PhoneNumberInput
                                            name={"phoneNumber"}
                                            value={phone}
                                            setValue={setPhone}
                                            fontSize={"14px"}
                                            required={true}
                                        />
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            License Number{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <input
                                            type="text"
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={licenseNumber}
                                            placeholder="License Number"
                                            onChange={(e) =>
                                                setLicenseNumber(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        />
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            License Expiry Date{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <CustomFormatDatePicker
                                            value={licenseExpiryDate}
                                            onChange={(value) => {
                                                setLicenseExpiryDate(value);
                                            }}
                                            required={true}
                                        />
                                    </div>

                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 my-2.5">

                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Status{" "}
                                            <span className="text-red-500">
                                                *
                                            </span>
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={status}
                                            onChange={(e) =>
                                                setStatus(
                                                    e.target.value
                                                )
                                            }
                                            required
                                        >
                                            <option value="available">
                                                Available
                                            </option>

                                            <option value="unavailable">
                                                Unavailable
                                            </option>

                                            <option value="on_trip">
                                                On Trip
                                            </option>

                                            <option value="inactive">
                                                Inactive
                                            </option>
                                        </select>
                                    </div>


                                    <div>
                                        <label className="block text-sm font-bold text-gray-700 mb-2 mt-2">
                                            Active?
                                        </label>

                                        <select
                                            className="w-full h-12 px-4 border border-gray-300 rounded-md bg-white outline-none focus:border-primary"
                                            value={enabled}
                                            onChange={(e) =>
                                                setEnabled(
                                                    e.target.value
                                                )
                                            }
                                        >
                                            <option value="Yes">
                                                Yes
                                            </option>

                                            <option value="No">
                                                No
                                            </option>
                                        </select>
                                    </div>

                                </div>

                                <div className="flex flex-col sm:flex-row gap-4 mt-6">

                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>

                                    <button
                                        type="button"
                                        onClick={() =>
                                            navigate(-1)
                                        }
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-white text-secondary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>

                                </div>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

            <PleasewaitPopup
                showPopup={pleaseWaitPopup}
            />
        </>
    );
};